import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../i18n/util";
import { applicationStore } from "../../stores/ApplicationStore";
import { ApplicationValues } from "../../types/models";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { CustomInputField } from "../ui/CustomInputField";
import { FormButtons } from "../ui/Primitives";
import { THEME } from "../../theme/ThemeStore";

type Props = { onSubmit: (application: ApplicationValues) => void; onBack: () => void };

export const MotivationForm = observer(({ onSubmit, onBack }: Props) => {
    const isMobile = useMobileMediaQuery();
    const isDal = THEME.THEME_NAME === "dal";

    const label =
        applicationStore.currentApplication.jobCategory &&
        ["trainee", "apprentice", "dual_study"].includes(applicationStore.currentApplication.jobCategory)
            ? t("screen.motivation.JobCategory")
            : t("screen.motivation.motivation");

    return (
        <>
            <div style={{ marginBottom: isMobile ? 23 : 36 }}>
                <h3 style={{ marginBottom: isDal ? 12 : undefined }}>{t("screen.motivation.title")}</h3>
                {isDal && <p className="applicationCaption">{t("screen.motivation.caption")}</p>}
            </div>
            <Formik initialValues={applicationStore.currentApplication} onSubmit={onSubmit}>
                {({ isValid, values, dirty }) => {
                    React.useEffect(() => {
                        if (values && dirty && isValid) {
                            applicationStore.isStepFinished["details"] = true;
                            applicationStore.currentApplication = values;
                        }
                    }, [dirty, isValid, values]);

                    return (
                        <Form style={isMobile ? {} : { height: "100%", flexGrow: 1 }}>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flexWrap: "wrap",
                                    height: "100%",
                                    justifyContent: isMobile ? "flex-start" : "space-between"
                                }}
                            >
                                <Field
                                    component={CustomInputField}
                                    label={label}
                                    name="motivation"
                                    multiline
                                    optional
                                    rows={isMobile ? 12 : 14}
                                    style={{ width: "100%" }}
                                />

                                <FormButtons
                                    labelBack={t("screen.details.button.back")}
                                    labelSubmit={t("screen.motivation.next")}
                                    middleButtons
                                    onBack={onBack}
                                    style={{ marginTop: 32 }}
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
});
